import { createSlice } from "@reduxjs/toolkit";
import { getClientData, getAllClientList } from "./thunk";

export const initialState ={
    clientData: [],
    allClient:[],
    error:[]
}

const ClientsSlice = createSlice({
    name: 'Data',
    initialState,
    reducer: {},
    extraReducers: (builder) => {
        builder.addCase(getClientData.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });
        builder.addCase(getClientData.fulfilled, (state, action) => {
            state.clientData = action?.payload;
        });
        builder.addCase(getAllClientList.fulfilled, (state, action) => {
            state.allClient= action?.payload
        })
        builder.addCase(getAllClientList.rejected, (state, action) => {
            state.error= action?.payload
        })
    }
});

export default ClientsSlice.reducer;